import { useState } from "react";
import s from "./Main.module.scss";
import Temoignage from "../Temoignage/Temoignage.jsx";
import CTA from "../CTA/CTA.jsx";
import Header from "../Header/Header.jsx";


const Main = () => {

    /*Calcul réduction fiscale Don libre */
    const [reductionFiscale, setReductionFiscale] = useState('_____');

    const [donationAmount, setDonationAmount] = useState('');

    const handleInputChange = (e) => {
        const inputValue = e.target.value;
        if (inputValue === '' || isNaN(Number(inputValue))) {
            setReductionFiscale('_____');
            setDonationAmount('');
            return;
        }
        const reduction = (Number(inputValue) * 0.66).toFixed(2);
        const donationAfterReduction = (Number(inputValue) - Number(reduction)).toFixed(0);
        setReductionFiscale(donationAfterReduction);
        setDonationAmount(inputValue);
    };

    /*Changement utm don libre à partir du résultat de l'input */
    const donationHref = `https://donner.avh.asso.fr/noel/?from=W26FALP&amount=${donationAmount || 100}&utm_source=lp&utm_medium=organic&utm_campaign=FA26`;



    return (
        <main>

            <Header />

            <section className={s.banner}>
                <h1>Ce ne sont pas ses yeux qui handicapent Louise... 
                    <br/>C’est le monde autour d’elle.
                </h1>
                <p>Le monde extérieur ne doit plus être un obstacle&nbsp;!</p>
            </section>

            <Temoignage />

            <section className={s.infoAVH}>
                <h2>Agissons ensemble pour l’autonomie des personnes déficientes visuelles&nbsp;!</h2>
                <p>Depuis plus de 135&nbsp;ans, les équipes pluridisciplinaires de l’association Valentin Haüy interviennent au plus près des personnes aveugles ou malvoyantes, afin de leur permettre de mener une vie sereine et pleinement autonome. 
                <br/>
                <br/>Pourtant, plus de 20&nbsp;ans après la loi du 11&nbsp;février&nbsp;2005 qui visait à garantir l’accessibilité universelle ainsi que l’égalité des droits pour les personnes en situation de handicap, <b>l’égalité n’est toujours pas réelle.</b>
                <br/>
                <br/>C’est pourquoi, chaque jour, l’association Valentin Haüy agit pour faire respecter les droits des personnes déficientes visuelles, favoriser leur inclusion dans la société et leur redonner de l’autonomie. <b>Votre soutien et votre mobilisation sont essentiels pour poursuivre et amplifier ces actions.</b></p>
            </section>

            <section className={s.don}>
                <h2>Découvrez comment agir à nos côtés</h2>
                <p className={s.firstText}><b>En faisant un don, contribuez à briser la solitude et l’isolement des personnes déficientes visuelles.</b> Votre don a un impact durable et immédiat et permettra à ces personnes de vivre pleinement en toute autonomie dans leur quotidien.</p>
                <div className={s.equivalence}>
                    <div className={s.equivalence__item}>
                        <p className={s.montant}>100&nbsp;€ soit 34&nbsp;€</p>
                        <p className={s.fisc}>après réduction fiscale*</p>
                        <p className={s.description}>Permettez à une personne touchée par le handicap visuel d’apprendre à se déplacer en toute sécurité grâce à nos cours de locomotion.</p>
                        <CTA 
                            variant="orange" 
                            place="form"
                            text="Je fais un don" 
                            href="https://donner.avh.asso.fr/noel/?from=W26FALP&amount=100&utm_source=lp&utm_medium=organic&utm_campaign=FA26" 
                        />
                    </div>
                    <div className={s.equivalence__item}>
                        <p className={s.montant}>200&nbsp;€ soit 68&nbsp;€</p>
                        <p className={s.fisc}>après réduction fiscale*</p>
                        <p className={s.description}>Contribuez à accompagner une personne aveugle ou malvoyante dans la réappropriation des gestes du quotidien.</p>
                        <CTA 
                            variant="orange" 
                            place="form"
                            text="Je fais un don" 
                            href="https://donner.avh.asso.fr/noel/?from=W26FALP&amount=200&utm_source=lp&utm_medium=organic&utm_campaign=FA26" 
                        />
                    </div>
                    <div className={s.equivalence__item}>
                        <p className={s.montant}>350&nbsp;€ soit 119&nbsp;€</p>
                        <p className={s.fisc}>après réduction fiscale*</p>
                        <p className={s.description}>Permettez à une personne déficiente visuelle de maîtriser les outils du numérique pour rester connectée, grâce à des cours d’informatique adaptée.</p>
                        <CTA 
                            variant="orange" 
                            place="form"
                            text="Je fais un don"  
                            href="https://donner.avh.asso.fr/noel/?from=W26FALP&amount=500&utm_source=lp&utm_medium=organic&utm_campaign=FA26"
                        />
                    </div>
                    <div className={s.equivalence__itemMobile}>
                        <p className={s.montant}>Montant libre</p>
                        
                        <div className={s.inputDonContainer}>
                            <input className={s.inputDon} type="number" aria-label="Autre don" placeholder="_ _ _ _ _" title="Autre don" onChange={handleInputChange} />
                            <p>€</p>
                        </div>

                        <p className={s.description}>Soit <span>{reductionFiscale} €</span> après réduction fiscale.</p>

                        <CTA 
                            variant="orange" 
                            place="form"
                            text="Je fais un don" 
                            href={donationHref}
                        />
                    </div>

                </div>
                <p className={s.note}>*Si vous êtes imposable sur le revenu, vous bénéficiez d’une réduction d’impôt de 66&nbsp;%, dans la limite de 20&nbsp;% de votre revenu imposable.</p>
            </section>

            <section className={s.defisc}>
                <h2>Découvrez l’impact de votre don en faveur de l’autonomie des personnes aveugles ou malvoyantes&nbsp;!</h2>
                <div className={s.temoignage}>
                    <p>Grâce aux ateliers de l’association Valentin Haüy, j’ai appris à me déplacer en toute sécurité, mais surtout, j’ai retrouvé confiance en moi. C’est ce qui m’a profondément marquée. Aujourd’hui, alors que les fêtes de fin d’année approchent, je ne redoute plus la foule ni les rues animées.</p>
                    <p className={s.person}>Louise, 69 ans</p>
                </div>
                <div className={s.centrer}>
                    <p>Grâce à votre générosité, nous mettons en œuvre toutes les solutions nécessaires à l’autonomie des personnes touchées par le handicap visuel que nous accompagnons. <b>En faisant un don avant le 31&nbsp;décembre, celui-ci sera déductible à 66&nbsp;% de votre impôt sur le revenu.</b></p>
                    <CTA 
                        place="sectionDefisc"
                        variant="orange"
                        text="Je fais un don"
                        href="https://donner.avh.asso.fr/noel/?from=W26FALP&amount=100&utm_source=lp&utm_medium=organic&utm_campaign=FA26"
                    />
                    <div className={s.ifi}>
                        <p>Et si vous êtes assujetti à l’IFI (impôt sur la fortune immobilière), 75&nbsp;% de votre don sont déductibles, dans la limite de 50&nbsp;000&nbsp;€. Celui-ci sera strictement affecté au centre de formation et aux entreprises adaptées de l’association.</p>
                        <CTA 
                            variant="violet" 
                            text="Je fais un don IFI" 
                            href="https://donner.avh.asso.fr/ifi/?from=IFIW26FA&utm_medium=lp&utm_source=organic&utm_campaign=FA26" 
                        />
                    </div>
                </div>
            </section>

            <section className={s.chiffres}>
                <h2>En 2025, votre générosité nous a permis de réaliser&nbsp;:</h2>
                <div className={s.chiffre__display}>
                    <div className={s.chiffre__item}>
                        <img src="/assets/chiffre/chiffre1.svg" alt="" />
                        <p className={s.style_h3}>1&nbsp;424&nbsp;h</p>
                        <p className={s.style_text}>de cours de locomotion</p>
                    </div>
                    <div className={s.chiffre__item}>
                        <img src="/assets/chiffre/chiffre2.svg" alt="" />
                        <p className={s.style_h3}>9&nbsp;236&nbsp;h</p>
                        <p className={s.style_text}>de cours de braille</p>
                    </div>
                    <div className={s.chiffre__item}>
                        <img src="/assets/chiffre/chiffre3.svg" alt="" />
                        <p className={s.style_h3}>7&nbsp;497&nbsp;h</p>
                        <p className={s.style_text}>de cours d’informatique adaptée</p>
                    </div>               
                </div>
            </section>
        </main>
    )
}

export default Main;